<template>
  <div>
    <div class="d-flex flex-wrap">
      <opq-text-field code="nom" v-model="carteAffaire.nom" disabled class="mr-3"></opq-text-field>

      <opq-text-field code="prenom" v-model="carteAffaire.prenom" disabled></opq-text-field>
    </div>

    <adresse
      :carte-affaire="carteAffaire"
      :addressComplete="addressComplete"
      adresseCode="adresse-perso"
      complementAdresseCode="complement-adresse-perso"
      villeCode="ville-perso"
      codePostalCode="code-postal-perso"
      provinceCode="province-perso"
      paysCode="pays-perso"
      telephoneCode="telephone-perso"
      courrielCode="courriel-perso"
      :two-columns="twoColumns"
      :endpoint="endpoint"
      :live="live"
      :no-phone="noPhone"
      :no-email="noEmail"
      :courrielOptional="courrielOptional"
      noNoteAcces
      noPosteTelephonique
    ></adresse>
  </div>
</template>

<script>
import Adresse from "@/components/FormParts/Adresse"

export default {
  components: { Adresse },
  props: {
    carteAffaire: { type: Object },
    addressComplete: { type: Boolean, default: true },
    twoColumns: { type: Boolean, default: false },
    live: { type: Boolean, default: true },
    endpoint: { type: String, default: "sas-cartes-affaires" },
    noPhone: { type: Boolean, default: false },
    noEmail: { type: Boolean, default: false },
    courrielOptional: { type: Boolean, default: false },
  },
}
</script>

<style></style>
